import 'bootstrap/js/dist/offcanvas.js';
import BigPicture from 'bigpicture';

for (const section of document.querySelectorAll('header,section')) {
	const observer = new IntersectionObserver(([entry]) => {
		if (entry.isIntersecting) {
			entry.target.classList.add('animate');
			observer.disconnect();
		}
	}, {
		threshold: location.pathname === '/' ? 0.15 : 0.35
	});
	observer.observe(section);
}

for (const image of document.querySelectorAll('img')) {
	if (image.parentElement?.tagName !== 'A') {
		image.onclick = () => {
			BigPicture({
				el: image,
				imgSrc: image.src,
				noLoader: true,
			});
		};
	}
}
